module.exports = __webpack_public_path__ + "web/img/s4.ca4e0187.png";